import { defineStore } from 'pinia'
import baseApi from '@/api/base'

export const useBaseStore = defineStore('base', {
  state: () => ({
    baseURL: baseApi.baseURL,
    timeout: baseApi.timeout,
    draftWs: baseApi.draft_ws,
  }),
  actions: {
    updateBaseURL(url) {
      this.baseURL = url
    },
    updateTimeout(timeout) {
      this.timeout = timeout
    },
    updateDraftWs(ws) {
      this.draftWs = ws
    },
  }
}) 